import React from 'react'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import PropTypes from 'prop-types';

class OrganisationName extends React.Component {
    static propTypes = {
        OrganisationQuery: PropTypes.shape({
            loading: PropTypes.bool,
            error: PropTypes.object,
            organisation: PropTypes.object,
          }).isRequired,          
      } 
      state = {
          refetched: 0
      }
  render () {    
    const cssClass = this.props.className ? this.props.className : ''
    if (this.props.OrganisationQuery.loading) {      
      return (<span className={"placeholder "+cssClass}>&nbsp;</span>)
    }
    if (this.props.OrganisationQuery.error) {
        if(this.state.refetched===0){            
            this.props.OrganisationQuery.refetch()
            this.setState({
                refetched: 1
            })
        }
        console.log(this.props.OrganisationQuery.error)
        return (<div>An unexpected error occurred</div>)
    }    
    
    return (    	
        <span className={cssClass}>
            {
                this.props.OrganisationQuery.organisation.name?
                this.props.OrganisationQuery.organisation.name
                :''
            }
        </span>
    )
  }
}


const getOrganisation = gql`
query organisation ($id: String!){
    organisation (id: $id)
    {
        id,        
        name,        
    }
  }`

const OrganisationNameData = compose(
    graphql(getOrganisation, {
        name: 'OrganisationQuery',
        options: (ownProps) => ({
            variables: {
                id: ownProps.organisationid
            },
            operation: 'query',
        })
    }),
)(OrganisationName)

export default OrganisationNameData


// WEBPACK FOOTER //
// ./src/organisations/OrganisationName.js